<template>
    <iframe v-if="seletedPlugin != null && !isNewRegistrationMethod" id="show-plugin" ref="iframeExternalPluginReports" style="width:100%;height:100%;" frameBorder=0>
    </iframe>
    <div v-else style="width:100%;height:100%;">
        <component :key="$route.fullPath" :is="currentcomponent"></component>
    </div>
</template>


<script>
import {mapMutations , mapGetters} from "vuex";
import Utils from "../../components.utils.js";
export default {
    data(){
      return{
        seletedPlugin:null,
        iframeController:null,
        registeredNotifications:[],
        currentcomponent:null,
        isNewRegistrationMethod:false,
      }
    },
    watch: {
      pluginInfo(ol, nl) {
        if (ol != nl) {
          if(this.isNewRegistrationType()){  
            this.loadPlugin(ol.id);
          }else{  
            this.isNewRegistrationMethod = false;
            setTimeout(() => this.selectPlugin(this.pluginInfo.pluginName), 100);
          }
        }  
      },
    },
    methods:{
      isNewRegistrationType(){
        let plugin =  this.pluginInfo;
        if(plugin && Object.prototype.hasOwnProperty.call(plugin,"reportsPluginLoadingInfo")){
          return true;
        }  
        return false;
      },
      isNewRegistrationMethodType(id){
          let plugin =  this.getRegisteredPluginMapper()[id];
          if(!plugin) return false;
          if(plugin && Object.prototype.hasOwnProperty.call(plugin,'reportsPluginLoadingInfo')){
              return true;
          }
          return false;
      },
      async loadPlugin(id){
            let plugin =  this.getRegisteredPluginMapper()[id];
            if(!plugin){ // in case if not found
                for(let key in this.getRegisteredPluginMapper()){
                    if(key == id){
                        plugin = this.getRegisteredPluginMapper()[key];
                    }
                }
            }
            console.log("Plugin......",plugin);
            if(plugin && Object.prototype.hasOwnProperty.call(plugin,'reportsPluginLoadingInfo')){
                this.isNewRegistrationMethod = true;
                let compInfo = await  Utils.loadPluginBundles([plugin.reportsPluginLoadingInfo.pluginBundle.js],plugin.reportsPluginLoadingInfo.eventName);
                Utils.loadCssBundle(plugin.reportsPluginLoadingInfo.pluginBundle.css);
                // if(compInfo[0] && compInfo[0].routes && Array.isArray(compInfo[0].routes)){
                //     for(let i = 0; i < compInfo[0].routes.length;i++){
                //         for(let j = 0; j < compInfo[0].routes[i].routes.length;j++){
                //             this.$router.addRoute(compInfo[0].routes[i].parentRouteName,compInfo[0].routes[i].routes[j]);
                //         }
                //     }
                // }
                // if(compInfo[0] && compInfo[0].childRoutes && Array.isArray(compInfo[0].childRoutes) && compInfo[0].childRoutes.length){
                //     for(let j = 0; j < compInfo[0].childRoutes.length;j++){
                //         this.$router.addRoute(compInfo[0].childRoutes[j].parentRouteName,compInfo[0].childRoutes[j].route);
                //     }
                // }
                if(compInfo[0].pluginStore && Array.isArray(compInfo[0].pluginStore) && compInfo[0].pluginStore.length){
                    for(let i = 0; i < compInfo[0].pluginStore.length; i++){
                      if(!this.$store.hasModule(compInfo[0].pluginStore[i].module))
                        this.$store.registerModule(compInfo[0].pluginStore[i].module,compInfo[0].pluginStore[i].store); // registers store dynamically at run time
                    }
                }else{
                  if(compInfo[0].pluginStore && !this.$store.hasModule(compInfo[0].pluginStore.module))
                      this.$store.registerModule(compInfo[0].pluginStore.module,compInfo[0].pluginStore.store); // registers store dynamically at run time
                }
                this.currentcomponent = compInfo[0].components.entry;
            }
        },
        selectPlugin(plugin){
          this.seletedPlugin = plugin;
          this.loadExternalPluginReportsSideMenu({id: this.seletedPlugin.id, pluginName: this.seletedPlugin,tagId: "show-plugin"})// eslint-disable-line no-undef
          this.iframeController = this.$refs.iframeExternalPluginReports.contentWindow;
          console.log("iframeController",this.iframeController)
        },
        damNotificationCallback(notification){
          notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
          this.iframeController.postMessage({
                    cmd: 'damNotification',
                    params: Object.assign({}, notification)
                    }, '*')
        },
        listenMessagesFromChild(){
          window.addEventListener('message', (event)=>{
            let cmd = event.data.cmd;
            switch (cmd) {
              case 'readyToListenMessage':{
                //your bussiness login goes here
                  // this.iframeController.postMessage({
                  //   cmd: 'fileinfo',
                  //   params: {
                  //     file_uid:'d42432342324342'
                  //   }
                  //   }, '*')
                  break;
                }
              case 'closeAnalyticsFullScreen':{
                this.$emit("fullscreenDisplayRequest",false)
                break;
              }
              case 'damNotification':{
                  let event_name = event.data.params.event_name
                  this.registeredNotifications.push({eventname:event_name, callback:this.damNotificationCallback,parent:"ExternalPluginReports"})
                  this.addWSEventListener({eventname:event_name, callback:this.damNotificationCallback,parent:"ExternalPluginReports"})
                  break;
                }
              default:
                break;
            }
          }
          )
        },
        ...mapMutations("registry",["loadExternalPluginReportsSideMenu"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapGetters("registry",["getRegisteredPluginMapper"]),
        ...mapGetters("pluginRepo",["getInstalledPluginsData"]),
    },
    props:["pluginInfo"],
    created(){
      this.listenMessagesFromChild();
    },
    mounted() {
      if(this.pluginInfo && this.pluginInfo.id){
        if(this.isNewRegistrationMethodType(this.pluginInfo.id)){
          this.loadPlugin(this.pluginInfo.id);
        }else{
           setTimeout(() => this.selectPlugin(this.pluginInfo), 100);
        }
      }else{
          let route = this.$router.resolve({path:window.location.pathname});
          if(route && route.route && route.route.params && route.route.params.pluginId){
              if(this.isNewRegistrationMethodType(route.route.params.pluginId)){
                 this.loadPlugin(route.route.params.pluginId);
              }else{
                   setTimeout(()=>{
                        for(let i = 0; i < this.getInstalledPluginsData().length; i++){
                            if(this.getInstalledPluginsData()[i].id == route.route.params.pluginId){
                                this.selectPlugin(this.getInstalledPluginsData()[i]);
                                break;
                            }
                        }
                   },100);
                  // setTimeout(() => this.selectPlugin(plugin.pluginName), 100);
              }
          }
      }
    },
    beforeDestroy(){
      for (const regnotification of this.registeredNotifications) {
        this.removeWSEventListener(regnotification)
      }
  },
}
</script>


<style lang="scss" scoped>
$header-background: #1a1a1a;
$border-color: 1px solid #3a3a3a;
$background: #121212;
$bg-color-on-hover: #141414;
$body-bg-color: #0d0d0d;
$dull-text-color: #757575;
$options-text-color: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$active-blue: #007bff;

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $text-color;
  letter-spacing: normal;
  margin-top: 60px;
  background: $body-bg-color !important;
  font-size: 14px !important;
  margin-block-start: 0em !important;
  margin-block-end: 0em !important;
  cursor: pointer;
  overflow: hidden;
}


body {
  background: $body-bg-color !important;
  color: $text-color;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $text-color;
  letter-spacing: normal;
  margin-top: 60px;
  background: $body-bg-color !important;
  height: 100%;
  font-size:14px !important;
  margin-block-start: 0em !important;
  margin-block-end: 0em !important;
  cursor: pointer;
  overflow:hidden;
}

html{
  overflow: auto;
}

select option {
    margin: 40px;
    background: #000;
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
}
</style>


